import { lazy } from 'react';

const LazyWhitelistIpEditView = lazy(() => import('./whitelist-ip-edit-view'));
export default LazyWhitelistIpEditView;
